
export function checkPermission(rule, value, callback) {
    console.log('rule', rule);
    console.log('value', value);
    console.log('callback', callback);
    if (value != '1' && value != '0' && value !='') {
        return callback(new Error('请输入1：私有，0：可被继承!!'));
    }
    else{
        
        callback();
    }
}

export function checkRequired(rule, value, callback) {
    console.log('rule', rule);
    console.log('value', value);
    console.log('callback', callback);
    if (value !== '1' && value !== '0' && value !=='') {
        return callback(new Error('请输入1：私有，0：可被继承!!'));
    }
    else{
        
        callback();
    }
}